<template>
  <v-select :searchable="false" :clearable="false" v-model="$i18n.locale"
    :options="langs" label="title" class="w-20 mx-4">
    <template class="flex"  #option="{title}">
      <img class="h-8 w-8" :src="require(`@/assets/images/language/${title}.png`)"/>
       <span class="text-white uppercase mx-2">{{title}}</span>
    </template>
    <template class="text-white" #selected-option="{ title }">
      <img class="h-8 w-8" :src="require(`@/assets/images/language/${title}.png`)"/>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'SelectLanguage',
  data() {
    return {
      langs: ['es', 'en'],
    };
  },
};
</script>

<style>
  #vs1__listbox.vs__dropdown-menu {
    background: transparent;
    min-width: 100px;
  }
  .vs__search {
    display: none;
  }

  #vs1__listbox .vs__dropdown-option {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }
</style>
